import React from 'react';

const HeroImage = () => (
  <svg
    className="prefix__animated"
    id="prefix__freepik_stories-agreement"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"

  >
      <style>
          {
              "@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes zoomOut{0%{opacity:0;transform:scale(1.5)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#prefix__freepik_stories-agreement:not(.prefix__animated) .prefix__animable{opacity:0}"
          }
      </style>
      <g
        id="prefix__freepik--Floor--inject-12"
        className="prefix__animable"
        style={{
            transformOrigin: "251.96px 362.157px",
            animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
            animationDelay: "0s",
        }}
      >
          <path
            id="prefix__freepik--floor--inject-12"
            d="M96.13 443.56c86.06 45 225.6 45 311.66 0s86.06-117.86 0-162.82-225.6-45-311.66 0-86.06 117.86 0 162.82z"
            style={{
                transformOrigin: "251.96px 362.157px",
            }}
            className="prefix__animable"
            fill="#f5f5f5"
          />
      </g>
      <g
        id="prefix__freepik--Shadows--inject-12"
        className="prefix__animable"
        style={{
            transformOrigin: "364.49px 367.195px",
            animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomOut",
            animationDelay: "0s",
        }}
      >
          <ellipse
            id="prefix__freepik--Shadow--inject-12"
            cx={329.49}
            cy={384.84}
            rx={40.89}
            ry={23.61}
            style={{
                transformOrigin: "329.49px 384.84px",
            }}
            className="prefix__animable"
            fill="#e0e0e0"
          />
          <ellipse
            id="prefix__freepik--shadow--inject-12"
            cx={404.21}
            cy={346.82}
            rx={36.17}
            ry={20.88}
            style={{
                transformOrigin: "404.21px 346.82px",
            }}
            className="prefix__animable"
            fill="#e0e0e0"
          />
      </g>
      <g
        id="prefix__freepik--Clouds--inject-12"
        className="prefix__animable"
        style={{
            transformOrigin: "376.075px 96.61px",
            animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
            animationDelay: "0s",
        }}
      >
          <g
            id="prefix__freepik--clouds--inject-12"
            className="prefix__animable"
            style={{
                transformOrigin: "376.075px 96.61px",
            }}
          >
              <path
                d="M372.08 78.84l6.4 3.69a6.18 6.18 0 01-.06-.85v-1.85c0-3.3 2.32-4.63 5.17-3a9.82 9.82 0 013.08 3c.47-4.15 3.72-5.69 7.67-3.41a17.09 17.09 0 017.73 13.39v2.77a7.32 7.32 0 01-.65 3.22l5.31 3.06a6.36 6.36 0 012.87 5c0 1.83-1.29 2.57-2.87 1.65l-34.65-20a6.35 6.35 0 01-2.86-5c0-1.85 1.28-2.59 2.86-1.67z"
                style={{
                    transformOrigin: "389.41px 90.6351px",
                }}
                id="prefix__elvh12mc49bh9"
                className="prefix__animable"
                fill="#ebebeb"
              />
              <path
                d="M344.72 97.47l4.83 2.78a4.6 4.6 0 01-.05-.64v-1.39c0-2.49 1.75-3.5 3.91-2.26a7.7 7.7 0 012.32 2.24c.35-3.13 2.81-4.29 5.79-2.57a12.89 12.89 0 015.83 10.11v2.09a5.46 5.46 0 01-.49 2.42l4 2.31a4.8 4.8 0 012.16 3.75c0 1.38-1 1.94-2.16 1.25l-26.15-15.1a4.75 4.75 0 01-2.16-3.74c.01-1.38.97-1.94 2.17-1.25z"
                style={{
                    transformOrigin: "357.785px 106.344px",
                }}
                id="prefix__elxswgvn3j0sq"
                className="prefix__animable"
                fill="#ebebeb"
              />
          </g>
      </g>
      <g
        id="prefix__freepik--Plants--inject-12"
        className="prefix__animable"
        style={{
            transformOrigin: "249.036px 345.436px",
            animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
            animationDelay: "0s",
        }}
      >
          <g
            id="prefix__freepik--plants--inject-12"
            className="prefix__animable"
            style={{
                transformOrigin: "56.3765px 366.216px",
            }}
          >
              <path
                d="M78.48 395.78c-.63.34-12.41 3.69-16.77-2.08s2.88-14.74-1.22-18.05-15.55 0-18.31-6.95 5.42-10 .82-17c-2.9-4.42-11-6.86-10.63-11 .54-6 11.61-7.64 21.29-1.19s14.18 1.16 17.26.73 9.69.52 9.47 11.3-1.91 44.24-1.91 44.24z"
                style={{
                    transformOrigin: "56.3765px 366.216px",
                }}
                id="prefix__el3yu8u0miqcw"
                className="prefix__animable"
                fill="#455a64"
              />
              <path
                d="M79.26 380.45a.64.64 0 01-.63-.54c-3.37-20.46-27.15-37.11-39.52-40.68a.66.66 0 01-.44-.8.64.64 0 01.8-.43c12.64 3.65 37 20.71 40.43 41.7a.65.65 0 01-.53.74z"
                style={{
                    transformOrigin: "59.2777px 359.211px",
                }}
                id="prefix__eleae4ly66fkq"
                className="prefix__animable"
                fill="#fff"
              />
              <path
                d="M51.22 363.32a.64.64 0 01-.55-.31.65.65 0 01.22-.88c.39-.23 9.54-5.58 18.55-3.08a.64.64 0 01.45.79.63.63 0 01-.79.45c-8.48-2.35-17.46 2.89-17.55 2.94a.63.63 0 01-.33.09z"
                style={{
                    transformOrigin: "60.2476px 360.853px",
                }}
                id="prefix__elho9j8ze9on"
                className="prefix__animable"
                fill="#fff"
              />
          </g>
          <g
            id="prefix__freepik--plants--inject-12"
            className="prefix__animable"
            style={{
                transformOrigin: "442.635px 317.969px",
            }}
          >
              <path
                d="M423.1 341.46L420 340s-1-11.19 0-18.66c2-13.91 11.71-25.9 20.36-27.31 11.14-1.81 9.16 8.44 2.79 12.87-10.15 7.1-18.05 17.83-20.05 34.56z"
                style={{
                    transformOrigin: "433.94px 317.639px",
                }}
                id="prefix__el2bd92g3winb"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__elb8by1so4i87">
                  <g
                    style={{
                        transformOrigin: "433.94px 317.639px",
                    }}
                    className="prefix__animable"
                    id="prefix__ela3jjqopn89"
                    opacity={0.1}
                  >
                      <path
                        d="M423.1 341.46L420 340s-1-11.19 0-18.66c2-13.91 11.71-25.9 20.36-27.31 11.14-1.81 9.16 8.44 2.79 12.87-10.15 7.1-18.05 17.83-20.05 34.56z"
                        id="prefix__eld461dspvpm"
                        className="prefix__animable"
                        style={{
                            transformOrigin: "433.94px 317.639px",
                        }}
                      />
                  </g>
              </g>
              <path
                d="M421.92 337h.08a.54.54 0 00.43-.63c-2.16-11.43 7.25-32.62 19.84-38.64a.54.54 0 00-.47-1c-13 6.2-22.66 28-20.44 39.82a.54.54 0 00.56.45z"
                style={{
                    transformOrigin: "431.814px 316.839px",
                }}
                id="prefix__elyk9wz1m2vcr"
                className="prefix__animable"
                fill="#fff"
              />
              <path
                d="M420 340c-.23-1.66-.33-4.08-.36-4.68a15.24 15.24 0 01.91-6.2 12.23 12.23 0 015.17-6.27c1.3-.75 2.82-1.29 3.66-2.53a8.08 8.08 0 00.95-3.71c.26-2.09.91-4.3 2.59-5.58s4-1.31 6-1.09c3 .32 5.81.72 8.61-.65a58.81 58.81 0 016.92-3.12c3-1 9.71-2.5 11.12 1.71a4.05 4.05 0 01-.61 3.43 12.28 12.28 0 01-2.52 2.57l-4.69 3.9a6 6 0 00-1.43 1.49c-.91 1.56-.26 3.53-.46 5.32a6.35 6.35 0 01-2.88 4.48 8.53 8.53 0 01-5.24 1.27c-2.45-.17-6.45-2.05-7.95.84a9.35 9.35 0 00-.72 3.1 6 6 0 01-1 3c-1 1.22-2.67 1.57-4.23 1.73a24.09 24.09 0 00-6.45 1c-.84.33-1.37 1.4-1.86 2.11-1.53-.51-3.21-1.12-5.53-2.12z"
                style={{
                    transformOrigin: "442.663px 323.595px",
                }}
                id="prefix__elj459bib7ti"
                className="prefix__animable"
                fill="#0b345a"
              />
              <path
                d="M421.37 339.16a.47.47 0 01-.23 0 .51.51 0 01-.28-.66c6.3-15.65 26.4-26.86 38.38-30.58a.5.5 0 01.63.34.51.51 0 01-.33.63c-11.79 3.66-31.57 14.66-37.74 30a.52.52 0 01-.43.27z"
                style={{
                    transformOrigin: "440.358px 323.536px",
                }}
                id="prefix__elaqsl1b7cpo8"
                className="prefix__animable"
                fill="#fff"
              />
          </g>
      </g>
      <g
        id="prefix__freepik--Pen--inject-12"
        className="prefix__animable"
        style={{
            transformOrigin: "219.115px 350.41px",
            animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
            animationDelay: "0s",
        }}
      >
          <g
            id="prefix__freepik--pen--inject-12"
            className="prefix__animable"
            style={{
                transformOrigin: "219.115px 350.41px",
            }}
          >
              <path
                d="M278.84 311.2a12.38 12.38 0 005.61 9.71 4.51 4.51 0 003.22.68 2.81 2.81 0 01-.61.48l1.35-.77.07-.05.2-.13a1.79 1.79 0 00.25-.22l.15-.15c0-.05.09-.1.13-.16a4 4 0 00.46-.84l.1-.27a.74.74 0 000-.14 2.1 2.1 0 00.06-.24 6.07 6.07 0 00.15-1.4 12.38 12.38 0 00-5.6-9.7 5 5 0 00-2.51-.77h-.35l-.32.06-.19.05h-.12a1.09 1.09 0 00-.23.09l-.21.11-1.17.67a2.37 2.37 0 01.6-.21 4.46 4.46 0 00-1.04 3.2zm9.23 10.26h.1z"
                style={{
                    transformOrigin: "284.404px 314.65px",
                }}
                id="prefix__elu8yakpjnfk"
                className="prefix__animable"
                fill="#0b345a"
              />
              <path
                d="M162.43 375.72l7.91 13.74 1.34-.78 115.38-66.61a2.81 2.81 0 00.61-.48 4.46 4.46 0 001-3.15 12.42 12.42 0 00-5.61-9.71 5.07 5.07 0 00-2.51-.76 2.81 2.81 0 00-.71.08 2.37 2.37 0 00-.6.21l-.1.05z"
                style={{
                    transformOrigin: "225.556px 348.715px",
                }}
                id="prefix__elx3x9r91jo6"
                className="prefix__animable"
                fill="#ebebeb"
              />
              <path
                d="M166.4 376.11c-3.1-1.79-5.61-.34-5.61 3.23a12.38 12.38 0 005.61 9.71c3.09 1.79 5.6.34 5.6-3.24a12.38 12.38 0 00-5.6-9.7z"
                style={{
                    transformOrigin: "166.395px 382.58px",
                }}
                id="prefix__el9n9pwpxoskt"
                className="prefix__animable"
                fill="#0b345a"
              />
              <path
                d="M154.35 384.44a.73.73 0 01.14-.16l7.15-7.87.06-.06.13-.14.07-.08c1-1 2.64-1.06 4.48 0a12.38 12.38 0 015.6 9.7c0 2.08-.85 3.43-2.16 3.86h-.08a3 3 0 01-.41.09h-.09l-10.36 2.26a2.51 2.51 0 01-1.81-.39 7.07 7.07 0 01-3.21-5.54 2.6 2.6 0 01.49-1.67z"
                style={{
                    transformOrigin: "162.918px 383.716px",
                }}
                id="prefix__el89no0e07br"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M246 333.4l.19-.11a1.45 1.45 0 011.3.19 4.4 4.4 0 012 3.45 1.47 1.47 0 01-.47 1.2l-.25.14-85.17 49.17-5.6-3.24z"
                style={{
                    transformOrigin: "203.747px 360.327px",
                }}
                id="prefix__elh7rs531cuyg"
                className="prefix__animable"
                fill="#455a64"
              />
              <path
                d="M171.5 382.86l-7.91 4.57-5.6-3.24L168.7 378a13.57 13.57 0 012.8 4.86z"
                style={{
                    transformOrigin: "164.745px 382.715px",
                }}
                id="prefix__elvv1tlpq6v"
                className="prefix__animable"
                fill="#37474f"
              />
              <path
                d="M151.53 388.17L158 381l.17-.19c.72-.72 1.88-.78 3.2 0a8.74 8.74 0 014 6.86c0 1.46-.59 2.41-1.51 2.72h-.06l-.26.06-9.54 2.1a1.53 1.53 0 01-1-.22 4 4 0 01-1.8-3.13 1.42 1.42 0 01.33-1.03z"
                style={{
                    transformOrigin: "158.283px 386.405px",
                }}
                id="prefix__el0i0snxok8mis"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__elehhxld2zhqr">
                  <path
                    d="M151.53 388.17L158 381l.17-.19c.72-.72 1.88-.78 3.2 0a8.74 8.74 0 014 6.86c0 1.46-.59 2.41-1.51 2.72h-.06l-.26.06-9.54 2.1a1.53 1.53 0 01-1-.22 4 4 0 01-1.8-3.13 1.42 1.42 0 01.33-1.03z"
                    style={{
                        transformOrigin: "158.283px 386.405px",
                    }}
                    className="prefix__animable"
                    id="prefix__eltlhbv00s47"
                    opacity={0.1}
                  />
              </g>
              <path
                d="M151.17 389.2a4 4 0 001.8 3.13 1.45 1.45 0 001 .21l4.8-1.05c.76-.16 1.26-.87 1.26-2a6.37 6.37 0 00-2.88-5 1.85 1.85 0 00-2.31 0l-.13.14-3.22 3.54a1.38 1.38 0 00-.32 1.03z"
                style={{
                    transformOrigin: "155.597px 388.321px",
                }}
                id="prefix__el0n4phhuz9q1m"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__eljolrroz74c8">
                  <path
                    d="M153 388.16c-1-.57-1.8-.11-1.8 1a4 4 0 001.8 3.13c1 .57 1.8.1 1.8-1.05a4 4 0 00-1.8-3.08z"
                    style={{
                        transformOrigin: "153px 390.223px",
                    }}
                    className="prefix__animable"
                    id="prefix__elbco7q03775"
                    opacity={0.1}
                  />
              </g>
              <path
                d="M267.17 321.15a1.39 1.39 0 011.41.14 4.39 4.39 0 012 3.43A1.37 1.37 0 01270 326l-21 12.1a1.47 1.47 0 00.47-1.2 4.4 4.4 0 00-2-3.45 1.45 1.45 0 00-1.3-.19z"
                style={{
                    transformOrigin: "258.379px 329.56px",
                }}
                id="prefix__elvdf1kc9nb9f"
                className="prefix__animable"
                fill="#fafafa"
              />
              <path
                d="M266.59 322.43a4.41 4.41 0 002 3.44 1.21 1.21 0 002-1.15 4.39 4.39 0 00-2-3.43 1.21 1.21 0 00-2 1.14z"
                style={{
                    transformOrigin: "268.591px 323.581px",
                }}
                id="prefix__elfhsqe8cgxgr"
                className="prefix__animable"
                fill="#f5f5f5"
              />
              <path
                d="M271 314h.07l.08-.05 8.27-4.77.2-.11a3.62 3.62 0 013.42.43 11.12 11.12 0 015 8.73 3.55 3.55 0 01-1.49 3.28l-8.37 4.83h-.05a3.62 3.62 0 01-3.5-.39 11.16 11.16 0 01-5-8.74A3.61 3.61 0 01271 314z"
                style={{
                    transformOrigin: "278.836px 317.723px",
                }}
                id="prefix__elhfoduoibwf9"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__el3d0wph8t0df">
                  <path
                    d="M271 314h.07l.08-.05 8.27-4.77.2-.11a3.62 3.62 0 013.42.43 11.12 11.12 0 015 8.73 3.55 3.55 0 01-1.49 3.28l-8.37 4.83h-.05a3.62 3.62 0 01-3.5-.39 11.16 11.16 0 01-5-8.74A3.61 3.61 0 01271 314z"
                    style={{
                        transformOrigin: "278.836px 317.723px",
                    }}
                    className="prefix__animable"
                    id="prefix__el91imyxptjh5"
                    opacity={0.05}
                  />
              </g>
              <g id="prefix__el29v2k3ywr4k">
                  <path
                    d="M274.69 314.23c-2.78-1.61-5-.3-5 2.91a11.16 11.16 0 005 8.74c2.79 1.61 5.05.3 5.05-2.91a11.15 11.15 0 00-5.05-8.74z"
                    style={{
                        transformOrigin: "274.715px 320.055px",
                    }}
                    className="prefix__animable"
                    id="prefix__elty1757xojc"
                    opacity={0.1}
                  />
              </g>
              <path
                d="M148.88 391.18l3.42-2.06a.62.62 0 01.67.05 2 2 0 01.93 1.6.68.68 0 01-.27.6l-3.41 2.06a1.38 1.38 0 01-.64.16 1.31 1.31 0 01-1.31-1.31 1.3 1.3 0 01.61-1.1z"
                style={{
                    transformOrigin: "151.086px 391.317px",
                }}
                id="prefix__el8fnipememx"
                className="prefix__animable"
                fill="#455a64"
              />
              <path
                d="M148.68 391.33l.18-.15a.69.69 0 01.6.1 2 2 0 01.92 1.6.65.65 0 01-.26.59h-.14a1 1 0 01-.42.07 1.31 1.31 0 01-1.31-1.31 1.33 1.33 0 01.43-.9z"
                style={{
                    transformOrigin: "149.317px 392.346px",
                }}
                id="prefix__elj55z3nlzhtf"
                className="prefix__animable"
                fill="#263238"
              />
          </g>
      </g>
      <g
        id="prefix__freepik--Agreement--inject-12"
        className="prefix__animable prefix__animator-active"
        style={{
            transformOrigin: "163.125px 220.267px",
            animation:
              "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomOut,1.5s Infinite linear floating",
            animationDelay: "0s,1s",
        }}
      >
          <g
            id="prefix__freepik--Contract--inject-12"
            className="prefix__animable"
            style={{
                transformOrigin: "163.125px 220.267px",
            }}
          >
              <path
                d="M82.67 400.31l-3.49-2a4.41 4.41 0 01-2-3.45V136.29a4.4 4.4 0 012-3.45l160.4-92.61a4.39 4.39 0 014 0l3.49 2a4.41 4.41 0 012 3.45v258.57a4.39 4.39 0 01-2 3.45L86.65 400.31a4.37 4.37 0 01-3.98 0z"
                style={{
                    transformOrigin: "163.125px 220.269px",
                }}
                id="prefix__elmtn288z5i5"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__elgllxtc1ugw9">
                  <path
                    d="M249 45.37c-.13-1-1-1.41-2-.83L86.65 137.15a4.19 4.19 0 00-1.41 1.48l-7.48-4.31a4.19 4.19 0 011.41-1.48l160.41-92.61a4.37 4.37 0 014 0l3.5 2a4.43 4.43 0 011.92 3.14z"
                    style={{
                        transformOrigin: "163.38px 89.1877px",
                    }}
                    className="prefix__animable"
                    id="prefix__el7j93tnyt52j"
                    fill="#fff"
                    opacity={0.4}
                  />
              </g>
              <g id="prefix__elli37616pd3r">
                  <path
                    d="M86.3 400.47a.31.31 0 01-.12 0l-.2.07h-.08c-.12 0-.24.06-.37.09a4.51 4.51 0 01-2.37-.19 3.62 3.62 0 01-.44-.2l-3.5-2a4.44 4.44 0 01-2-3.45v-258.5a4.21 4.21 0 01.58-2l7.48 4.31a4 4 0 00-.59 2v258.57a1.62 1.62 0 00.31 1.05 1 1 0 001.06.34 1.31 1.31 0 00.24-.09z"
                    style={{
                        transformOrigin: "81.76px 267.499px",
                    }}
                    className="prefix__animable"
                    id="prefix__el4c9utv6xybo"
                    opacity={0.15}
                  />
              </g>
              <path
                d="M198.94 87.84l-.29-.18-3.31-1.9a12.25 12.25 0 00-3.87-1.37c-.57-.13-1.08-.28-1.53-.43a11.62 11.62 0 01-1.46-.59l.24-.31-3.72-2.17a3.93 3.93 0 00-1-.39c-1.41-.35-3.52.47-5.62.23a5.23 5.23 0 01-3.82-2.27c-1.28-1.72-2.05-4.73-3.18-7.23l1-1.45a3.07 3.07 0 00-.31-.17l-3.43-2a3.76 3.76 0 00-1.91-.52 7.32 7.32 0 00-3.6 1.17c-8.21 4.75-8.49 16-11.45 23.42s-7.15 9.73-9.43 12.92-2.44 5.55-7.49 12.51-5.25 8.66-5.25 10v10.37l3.74 2.16 67.22-38.83zm-61.64 40c-.87.49-1.59-.18-1.59-1.53a4.25 4.25 0 011.59-3.37c.87-.5 1.58.19 1.58 1.54a4.22 4.22 0 01-1.58 3.34zm29.53-29.11a3.38 3.38 0 01-5.17-1.58c-2.61.5-4.55-2-4.55-6.34 0-5.1 2.69-10.77 6-12.69a3.38 3.38 0 015.17 1.59c2.61-.52 4.54 2 4.54 6.33 0 5.08-2.67 10.75-5.99 12.67zm22.33-.84c-.88.51-1.59-.17-1.59-1.52a4.15 4.15 0 011.59-3.37c.88-.51 1.59.17 1.59 1.52a4.16 4.16 0 01-1.59 3.35z"
                style={{
                    transformOrigin: "164.99px 103.365px",
                }}
                id="prefix__el67zld2axige"
                className="prefix__animable"
                fill="#455a64"
              />
              <g id="prefix__els19659za6q">
                  <path
                    d="M137 129.67l-7.23-4.17a5.16 5.16 0 00-.24 1.61v10.37l3.74 2.16 3.73-2.16z"
                    style={{
                        transformOrigin: "133.265px 132.57px",
                    }}
                    className="prefix__animable"
                    id="prefix__ely4fbztww1i"
                    fill="#37474f"
                    opacity={0.5}
                  />
              </g>
              <g id="prefix__elcyr209d8vc">
                  <path
                    d="M144.43 116.73l3.74-8.63-5.94-3.48c-1.74 2.41-2.25 4.36-4.59 8.19z"
                    style={{
                        transformOrigin: "142.905px 110.675px",
                    }}
                    className="prefix__animable"
                    id="prefix__elffskpy849ya"
                    fill="#37474f"
                    opacity={0.5}
                  />
              </g>
              <g id="prefix__elkymio2rc4ia">
                  <path
                    d="M159.38 99.48l.48-2.52c-1.65-.69-2.75-2.92-2.75-6.17 0-4.33 1.94-9.06 4.55-11.57l-5.18-3c-2.2 5-3 11-4.82 15.47-.38 1-.79 1.83-1.2 2.63z"
                    style={{
                        transformOrigin: "156.06px 87.85px",
                    }}
                    className="prefix__animable"
                    id="prefix__elc5ynqniafwp"
                    fill="#37474f"
                    opacity={0.5}
                  />
              </g>
              <path
                d="M198.94 87.84l-.29-.18a15.07 15.07 0 00-3.45-1.12 10.72 10.72 0 01-5.26-2.54 7.65 7.65 0 00-1.22-.9 3.48 3.48 0 00-1-.4c-2.26-.55-6.38 1.92-9.34-1.92a.54.54 0 01-.09-.12c-2.07-2.78-2.83-9-5.93-10.83a3.07 3.07 0 00-.31-.17c-1.28-.6-2.94-.49-5.22.81-8.21 4.75-8.49 16-11.45 23.42s-7.14 9.73-9.42 12.92-2.43 5.55-7.49 12.51-5.24 8.67-5.24 10v10.38l67.22-38.83V90.45a2.6 2.6 0 00-1.51-2.61zM141 130c-.88.51-1.59-.17-1.59-1.53a4.18 4.18 0 011.59-3.36c.88-.51 1.58.18 1.58 1.53A4.18 4.18 0 01141 130zm25.8-31.26a3.38 3.38 0 01-5.17-1.58 9.52 9.52 0 01-.82-4.19c0-5.09 2.68-10.77 6-12.68a4.74 4.74 0 011.45-.57c2.61-.52 4.54 2 4.54 6.33.02 5.07-2.65 10.74-5.97 12.66zm26.09 1.26c-.88.51-1.59-.17-1.59-1.51a4.15 4.15 0 011.59-3.36c.87-.51 1.58.17 1.58 1.52a4.17 4.17 0 01-1.58 3.35z"
                style={{
                    transformOrigin: "166.846px 104.505px",
                }}
                id="prefix__elis3bq1gdvl"
                className="prefix__animable"
                fill="#37474f"
              />
              <path
                d="M172.82 86c0 5.1-2.67 10.77-6 12.69a3.38 3.38 0 01-5.17-1.58 5 5 0 001.45-.57c3.31-1.92 6-7.59 6-12.69a9.59 9.59 0 00-.82-4.18c2.61-.5 4.54 2.01 4.54 6.33z"
                style={{
                    transformOrigin: "167.235px 89.4732px",
                }}
                id="prefix__elc2r255dy35k"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M141 130c-.88.5-1.59-.18-1.59-1.52a4.2 4.2 0 011.59-3.37c.87-.51 1.58.19 1.58 1.53A4.21 4.21 0 01141 130"
                style={{
                    transformOrigin: "140.995px 127.554px",
                }}
                id="prefix__elx9lttmerb58"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M192.89 100c-.88.5-1.59-.17-1.59-1.52a4.2 4.2 0 011.59-3.37c.87-.5 1.58.19 1.58 1.54a4.2 4.2 0 01-1.58 3.35"
                style={{
                    transformOrigin: "192.885px 97.5563px",
                }}
                id="prefix__elkqu5b1x8q0g"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M97.06 161.34l139.58-80.59a2.65 2.65 0 012.39 0l1.35.78a2.64 2.64 0 011.19 2.07v212.94a2.62 2.62 0 01-1.19 2.07L100.8 379.2a2.65 2.65 0 01-2.39 0l-1.35-.78a2.63 2.63 0 01-1.2-2.07V163.41a2.65 2.65 0 011.2-2.07z"
                style={{
                    transformOrigin: "168.715px 229.975px",
                }}
                id="prefix__elytjd8lf6cbk"
                className="prefix__animable"
                fill="#f5f5f5"
              />
              <path
                d="M241.53 83.24c-.15-.49-.61-.65-1.15-.33L100.8 163.5a2.28 2.28 0 00-.85.89l-3.74-2.15a2.46 2.46 0 01.85-.9l139.58-80.59a2.65 2.65 0 012.39 0l1.35.78a2.65 2.65 0 011.15 1.71z"
                style={{
                    transformOrigin: "168.87px 122.428px",
                }}
                id="prefix__ellhnmvfou19"
                className="prefix__animable"
                fill="#fafafa"
              />
              <path
                d="M100.51 379.33a2.83 2.83 0 01-.44.12h-.23a3.57 3.57 0 01-.73 0 3.17 3.17 0 01-.44-.12l-.27-.13-1.34-.77a2.65 2.65 0 01-1.19-2.07V163.41a2.32 2.32 0 01.34-1.17l3.74 2.15a2.51 2.51 0 00-.35 1.18v212.94c0 .65.4.97.91.82z"
                style={{
                    transformOrigin: "98.19px 270.854px",
                }}
                id="prefix__el2cj5nva9w3q"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M210.13 110.91l-3.72-2.15a4 4 0 00-3.73.11c-4.34 1.91-6.22 2.78-8.46 3.72l-1.62.65c-.88.35-2.63.05-2.09-3l5.77-15.53h-.09l-3.65-2.11a1.52 1.52 0 00-.61-.22h-.4c-2.36-.06-3-15.29-3.05-15.76l-.17-.09-3.61-2.08a4 4 0 00-2.06-.52 7.59 7.59 0 00-3.43 1c-5.67 3-11.4 11.81-12.8 19.74-.88 5-5.91 12.7-8.82 15.54s-3.11 5.2-3.11 5.2l-2.26 12.82-.73 4.11c-.53 3.06-3.67 6-3.67 6L136.11 147c-7.33 6.08-9.4 12.23-10.8 19.83v.06c0 .27 0 .45.13.52a.12.12 0 00.13 0l1.5-.85 80.56-46.46a1.74 1.74 0 00.73-1.12c.46-2.77 1.8-8 1.8-8zm-23.29-23.53c-.87 4.87-4.38 10.31-7.87 12.14-2.41 1.26-4.17.48-4.76-1.74a2.77 2.77 0 01-2.64-.34c-1.12-.88 9.14-18.5 10-18.11a3 3 0 011.55 2.1c2.88-.87 4.49 1.57 3.72 5.95z"
                style={{
                    transformOrigin: "167.735px 120.679px",
                }}
                id="prefix__el2wl3ecryquj"
                className="prefix__animable"
                fill="#455a64"
              />
              <g id="prefix__elyfgn58enrem">
                  <path
                    d="M137 155.56l-5.87-3.39c-3.4 4.48-4.77 9.19-5.78 14.66v.06c0 .27 0 .45.13.52a.12.12 0 00.13 0l4.63-3.66z"
                    style={{
                        transformOrigin: "131.175px 159.8px",
                    }}
                    className="prefix__animable"
                    id="prefix__elwmjzn91ymc"
                    fill="#37474f"
                    opacity={0.5}
                  />
              </g>
              <g id="prefix__elz9iqpqwotf">
                  <path
                    d="M151.1 133.53l8.28 4.77 3.73-21.57-7.46-4.31a7.1 7.1 0 00-1.17 2.85l-2.26 12.82-.73 4.11a6.5 6.5 0 01-.39 1.33z"
                    style={{
                        transformOrigin: "157.105px 125.36px",
                    }}
                    className="prefix__animable"
                    id="prefix__elagx8jtukk5"
                    fill="#37474f"
                    opacity={0.5}
                  />
              </g>
              <g id="prefix__elnp8n4vhh05">
                  <path
                    d="M170.33 84.23a32.32 32.32 0 00-3.92 10.3 25.92 25.92 0 01-2.92 7.32l7.09 4.1 3.53-8.15a2.74 2.74 0 01-2.54-.36c-.58-.46 1.86-5.33 4.47-9.91z"
                    style={{
                        transformOrigin: "169.765px 95.09px",
                    }}
                    className="prefix__animable"
                    id="prefix__elnw9ka7sv5jp"
                    fill="#37474f"
                    opacity={0.5}
                  />
              </g>
              <path
                d="M210.18 110.94h-.05a4.08 4.08 0 00-3.72.12c-5.32 2.35-6.93 3.12-10.09 4.37-.84.34-2.55.07-2.1-2.81a1.36 1.36 0 010-.2l.73-4.1 2-11.17s.46-1.76-.7-2.42h-.09a2.17 2.17 0 00-.93-.2 4.55 4.55 0 01-3.33-2.13 8.4 8.4 0 01-1.25-6.39c.85-4.79-.08-8.15-2.2-9.4l-.17-.1c-1.37-.73-3.21-.61-5.36.52-5.68 3-11.41 11.81-12.8 19.74-.89 5-5.92 12.71-8.83 15.54s-3.1 5.2-3.1 5.2L156 130.26l-.72 4.1c-.54 3.06-3.68 6-3.68 6l-11.7 8.78a28.23 28.23 0 00-9.63 14.57s-4.39 3.41-4.66 3.68l1.5-.85 80.79-46.44s.92-.51 1.13-.64 3.46-3.2 3.46-3.2c-.18-2.62-.96-4.51-2.31-5.32zm-23.34-23.56c-.87 4.87-4.38 10.31-7.87 12.14-2.41 1.26-4.17.48-4.76-1.74a9.14 9.14 0 010-3.78c.87-4.88 4.39-10.31 7.88-12.13a6.28 6.28 0 011-.44c2.91-.87 4.52 1.57 3.75 5.95z"
                style={{
                    transformOrigin: "169.05px 121.721px",
                }}
                id="prefix__ell2v90jf28h"
                className="prefix__animable"
                fill="#37474f"
              />
              <path
                d="M186.84 87.38c-.87 4.87-4.38 10.31-7.87 12.14-2.41 1.26-4.17.48-4.76-1.74a6.9 6.9 0 001-.42c3.5-1.83 7-7.27 7.87-12.15a9.17 9.17 0 000-3.78c2.92-.87 4.53 1.57 3.76 5.95z"
                style={{
                    transformOrigin: "180.621px 90.689px",
                }}
                id="prefix__elkdbym2cfwe"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M183.47 81.64a1.9 1.9 0 011.68.82c1.45 2.06.06 7.3-.54 9-.83 2.33-6.25 7.81-7.74 7.81a3.68 3.68 0 01-2.45-1.57 9.07 9.07 0 010-3.64c.85-4.82 4.33-10.18 7.76-12a6.64 6.64 0 01.95-.41h.33m0-.23h-.37a6.28 6.28 0 00-1 .44c-3.49 1.82-7 7.25-7.88 12.13a9.14 9.14 0 000 3.78 3.94 3.94 0 002.65 1.7c1.62 0 7.07-5.53 7.94-8s2.76-10.11-1.36-10.11z"
                style={{
                    transformOrigin: "180.004px 90.415px",
                }}
                id="prefix__elo3854k1pktr"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M125.57 167.42l82.28-47.3 1.14-.63c.2-.12 3.45-3.21 3.45-3.21l-82.22 47.46s-4.98 3.86-4.65 3.68z"
                style={{
                    transformOrigin: "168.997px 141.853px",
                }}
                id="prefix__eltj9ssps6vkc"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M114.54 200.59v1.87c0 1 .72 1.43 1.6.92L225 140.52a3.54 3.54 0 001.6-2.76v-1.88c0-1-.72-1.43-1.6-.92l-108.86 62.87a3.53 3.53 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 169.17px",
                }}
                id="prefix__elqc3mf0pqc7"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 211.9v1.87c0 1 .72 1.43 1.6.92L225 151.82a3.53 3.53 0 001.6-2.76v-1.88c0-1-.72-1.42-1.6-.92l-108.86 62.88a3.53 3.53 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 180.477px",
                }}
                id="prefix__elhw23nm525fg"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 223.14V225c0 1 .72 1.43 1.6.92L225 163.07a3.54 3.54 0 001.6-2.76v-1.88c0-1-.72-1.43-1.6-.92l-108.86 62.87a3.53 3.53 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 191.715px",
                }}
                id="prefix__elizu3fny8l3i"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 248.05v1.87c0 1 .72 1.43 1.6.92L225 188a3.53 3.53 0 001.6-2.76v-1.88c0-1-.72-1.42-1.6-.92l-108.86 62.85a3.53 3.53 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 216.642px",
                }}
                id="prefix__elk9znq932ynj"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 259.35v1.88c0 1 .72 1.42 1.6.92L225 199.28a3.53 3.53 0 001.6-2.76v-1.88c0-1-.72-1.43-1.6-.92l-108.86 62.87a3.54 3.54 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 227.933px",
                }}
                id="prefix__el2ve1xiv468o"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 270.6v1.87c0 1 .72 1.43 1.6.92L225 210.52a3.53 3.53 0 001.6-2.76v-1.88c0-1-.72-1.42-1.6-.92l-108.86 62.88a3.53 3.53 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 239.177px",
                }}
                id="prefix__elhyv7qnqu8c6"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 295.5v1.88c0 1 .72 1.42 1.6.92L225 235.43a3.53 3.53 0 001.6-2.76v-1.88c0-1-.72-1.43-1.6-.92l-108.86 62.87a3.54 3.54 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 264.083px",
                }}
                id="prefix__el8s3l4a2bil6"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 306.81v1.87c0 1 .72 1.43 1.6.92L225 246.73a3.51 3.51 0 001.6-2.75v-1.88c0-1-.72-1.43-1.6-.92l-108.86 62.87a3.53 3.53 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 275.39px",
                }}
                id="prefix__elom0baglgxq"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M114.54 318.05v1.88c0 1 .72 1.42 1.6.92L225 258a3.53 3.53 0 001.6-2.76v-1.88c0-1-.72-1.43-1.6-.92l-108.86 62.85a3.54 3.54 0 00-1.6 2.76z"
                style={{
                    transformOrigin: "170.57px 286.643px",
                }}
                id="prefix__el0ppdaet8t279"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                style={{
                    transformOrigin: "198.605px 303.925px",
                }}
                id="prefix__elu473p5xufis"
                className="prefix__animable"
                fill="#e0e0e0"
                d="M170.58 319.56l56.05-32.35v1.08l-56.05 32.35v-1.08z"
              />
              <path
                d="M183.62 302.76c2.33-1.56 4.93-4.19 4.51-7.3-.25-1.89-1.79-2.62-3.53-1.95-3.41 1.31-5.56 6.44-6.75 9.54-1 2.71-2.37 7.82 1.7 8.69 4.77 1 8.46-6 9.54-9.64.15-.51-.68-.79-.92-.33-.42.83-3.23 6.31-.14 5.62 1.1-.24 1.73-1.95 2.13-2.82.7-1.56 1.05-3.73 2.15-5.07l-.81-.37c.05 1.44 0 2.42 1 3.54a.49.49 0 00.68.11c1.58-1.47 1.69-3.86 3.43-5.19l-.71-.34c0 .46-.21 1.77-.24 2.38 0 .29.39.48.62.39a1.36 1.36 0 001-.86l-.76-.28c.66 3.53 3.67 0 4.7-1.34 3-4 5.14-8.29 5.22-13.41 0-.41-.77-.62-.78-.13-.07 3.94-1.79 7.55-2.9 11.27-1.19 4-2.18 8.09-3 12.21l.71.26a24.52 24.52 0 012.2-8.42 16.65 16.65 0 013.79-6.32l-.66-.25a7.14 7.14 0 01-1.6 5.82c-.21.27.26.78.47.51 1.1-1.38 2.91-1.82 4.09-3.16a35 35 0 002.95-4.76l-.54-.27c-.07 3.36 3.1-1.88 3.53-2.44l-.52-.2c.21.69.49 1.15 1.27 1.16 1.55 0 2.13-2.26 3.3-2.52 0 0 .51.43.69.45a2.93 2.93 0 001.87-.35 8.7 8.7 0 003.06-3.42c.18-.32-.43-.72-.63-.37-.77 1.3-3.17 4.75-4.91 3.06-.11-.1-.34-.2-.46-.06-.47.58-3.16 3.66-3.66 2-.06-.2-.35-.42-.51-.2-.41.54-.74 1.14-1.12 1.71-.21.31-1.38 2.28-1.34 1.28 0-.24-.37-.52-.54-.27-1.09 1.67-1.89 3.86-3.41 5.22-1.13 1-2.61 1.38-3.59 2.59l.47.51a7.66 7.66 0 001.83-6.32.42.42 0 00-.66-.25c-1.87 1.72-2.92 4.14-3.85 6.46a25.27 25.27 0 00-2.24 8.59c0 .31.63.66.71.26a118.83 118.83 0 013.29-13.16c1.1-3.48 2.59-6.83 2.66-10.53l-.78-.13a19.39 19.39 0 01-3.47 10.7c-.56.87-1.15 1.74-1.79 2.56-.28.37-2.76 3.61-3.08 1.73-.05-.27-.58-.65-.76-.28l-.72.64.62.38c.05-.81.21-1.57.25-2.39 0-.31-.48-.51-.71-.33-1.77 1.35-1.9 3.74-3.49 5.21l.68.11a5.41 5.41 0 01-.76-3c0-.35-.54-.69-.81-.37-1.22 1.46-1.6 3.79-2.4 5.49-.44.93-2 3.41-1.5.77a13 13 0 011.41-3.11l-.92-.33c-.94 3.18-3.45 8-6.88 9-4.38 1.31-3.62-4.12-2.82-6.54a26.94 26.94 0 014.18-7.82 8.71 8.71 0 011.13-1.3c.89-.8 1.15-1 2.39-.29s1.3 1.1 1 2.44a7.37 7.37 0 01-.82 1.89 12.55 12.55 0 01-2.94 3.14c-.16.13.07.56.25.43z"
                style={{
                    transformOrigin: "200.6px 297.45px",
                }}
                id="prefix__el96ola73ffzh"
                className="prefix__animable"
                fill="#455a64"
              />
          </g>
      </g>
      <g
        id="prefix__freepik--Characters--inject-12"
        className="prefix__animable"
        style={{
            transformOrigin: "370.085px 287.267px",
            animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
            animationDelay: "0s",
        }}
      >
          <g
            id="prefix__freepik--characters--inject-12"
            className="prefix__animable"
            style={{
                transformOrigin: "370.085px 287.267px",
            }}
          >
              <path
                d="M318 240.38c-3.62-.86-7.61 1.72-9.94 7.4s-7 20.2-8 24c-.44 1.7 12.48 16.76 12 16.54-.14-.07 4.21-7.35 4.21-7.35l-6.27-9.65 4-10.47z"
                style={{
                    transformOrigin: "309.025px 264.27px",
                }}
                id="prefix__elof9joxyjw7e"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M309.62 375.18c-.49.19-.62 1.12-.69 3-.06 1.41-.36 3.86 1.29 4.35s4.06.24 5.12-1.08a65 65 0 014.09-5.13c1.63-1.76 3.39-3.39 4.05-5.85.6-2.22.1-3.18-1.41-3.83-2.09-.88-5.36 2-7 2.47-1.39.38-4.96 5.89-5.45 6.07z"
                style={{
                    transformOrigin: "316.299px 374.618px",
                }}
                id="prefix__elymwrgqaek6"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M309.62 373.46v2.28a5.6 5.6 0 005.77.16c.1-.22.6-3.27.6-3.27z"
                style={{
                    transformOrigin: "312.805px 374.626px",
                }}
                id="prefix__elm8vheymxzrd"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M326.6 387.31a38.35 38.35 0 00-1 3.72c-.29 1.38-.69 3.69-.2 4.72s2.36 1.71 5.29 1.69c1.89 0 4.84 1.27 6.86 2.4a10.58 10.58 0 006.55.91c2.6-.31 5.3-1.82 5.72-2.89s-.12-1.6-6.25-4.21c-.06 0-6.46-2.92-9.43-6.19z"
                style={{
                    transformOrigin: "337.549px 394.115px",
                }}
                id="prefix__el93wfqfchui"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M326.6 384.84v2.66c0 .97 1.14 2.41 4.1 2.31 2.08-.08 3.53-.64 3.44-2.35V385z"
                style={{
                    transformOrigin: "330.372px 387.327px",
                }}
                id="prefix__el46tbsw6f76"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M307.37 341.82a54.22 54.22 0 012.79-11.74s-1.29-10.1-2-19.8c-1.33-17.39-.26-23.07 3.16-30.87 0 0 29.17-3 30.06 9.17 1.11 15.1-.36 44.28-.76 49.61s-.9 7.74-2.78 18.88c-1.44 8.48-3.66 27.93-3.66 27.93a8 8 0 01-7.54-.16s-2.38-24.28-2.13-30.43A52.28 52.28 0 01326.8 341s-1.81-24.61-2.33-28.53c0 0-.92 7.81-1.32 13.14s-2 10.43-3.52 20.34c-1.34 8.59-3.83 27.8-3.83 27.8-3.87 2.1-6.18-.27-6.18-.27s-3.29-24.21-2.25-31.66z"
                style={{
                    transformOrigin: "324.477px 332.475px",
                }}
                id="prefix__elg0ov003p7qd"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__eldk5j5od8rp6">
                  <g
                    style={{
                        transformOrigin: "324.477px 332.475px",
                    }}
                    className="prefix__animable"
                    id="prefix__ela8op93odpk"
                    opacity={0.35}
                  >
                      <path
                        d="M307.37 341.82a54.22 54.22 0 012.79-11.74s-1.29-10.1-2-19.8c-1.33-17.39-.26-23.07 3.16-30.87 0 0 29.17-3 30.06 9.17 1.11 15.1-.36 44.28-.76 49.61s-.9 7.74-2.78 18.88c-1.44 8.48-3.66 27.93-3.66 27.93a8 8 0 01-7.54-.16s-2.38-24.28-2.13-30.43A52.28 52.28 0 01326.8 341s-1.81-24.61-2.33-28.53c0 0-.92 7.81-1.32 13.14s-2 10.43-3.52 20.34c-1.34 8.59-3.83 27.8-3.83 27.8-3.87 2.1-6.18-.27-6.18-.27s-3.29-24.21-2.25-31.66z"
                        id="prefix__elywk0q5bu5fb"
                        className="prefix__animable"
                        style={{
                            transformOrigin: "324.477px 332.475px",
                        }}
                      />
                  </g>
              </g>
              <path
                style={{
                    transformOrigin: "327.27px 241.02px",
                }}
                id="prefix__elf01r6zysq6"
                className="prefix__animable"
                fill="#b16668"
                d="M332.91 236.45l-1.37 11.27-9.91-.89 1.13-12.51 10.15 2.13z"
              />
              <path
                d="M310.75 246c1.09-3 4.8-6.27 8.61-5.56l2.8.51c.08 2.6 5 3.94 9.86 2.37 1.46.42 2.81.85 4 1.28 3.49 1.25 4.89 7 5 16.74s1.11 33.87 1.11 33.87l-4.13 1.31-1.9-7.07-.77 8.47a30.37 30.37 0 01-14.09-.07c-10.48-2.29-13.74-7.94-13.74-7.94a51.15 51.15 0 017.5-18.33c-5.24-13.97-5.86-21.15-4.25-25.58z"
                style={{
                    transformOrigin: "324.815px 269.528px",
                }}
                id="prefix__elibgtdhyoa5h"
                className="prefix__animable"
                fill="#ebebeb"
              />
              <path
                d="M340.28 222.13a8.71 8.71 0 00-.75-8.38c-3.33-5.22-9.74-6.11-17.34-4.07a13.47 13.47 0 00-9.51 12.24c-.37 5.57 15.18 9.68 14.82 13.5z"
                style={{
                    transformOrigin: "326.846px 222.044px",
                }}
                id="prefix__el1tf4ek8csca"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M340.61 224.25s2.11 3.38 1.81 3.73a5.27 5.27 0 01-1.7.68z"
                style={{
                    transformOrigin: "341.53px 226.455px",
                }}
                id="prefix__eljliw38xk0up"
                className="prefix__animable"
                fill="#9a4a4d"
              />
              <path
                d="M334.18 213.54c2.1 1.16 5.74 3.3 6.48 11.2.76 8.1-1.12 10.86-2.25 11.89-.76.7-4.61.85-6.59.18-2.48-.85-7.84-3.67-10.27-7.91-2.86-5-3.3-11.55.22-14a12.89 12.89 0 0112.41-1.36z"
                style={{
                    transformOrigin: "330.051px 224.891px",
                }}
                id="prefix__el9hgjoaqf52v"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M334.8 213.89s1.66 7.42-.7 12c0 0-1.22-2.91-3.72-2.15s-2.37 4.09-.46 5.84a3.7 3.7 0 003.84.92 16.61 16.61 0 01-3.71 5.6s-7.39 3.29-13.78-3.93c-5.81-6.55-4.73-18 4.16-20.67s14.37 2.39 14.37 2.39z"
                style={{
                    transformOrigin: "324.014px 223.785px",
                }}
                id="prefix__eldibv7of1qwb"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M313.73 214.66a1.74 1.74 0 01.19 2.45l-2.64-2.27a1.73 1.73 0 012.45-.18z"
                style={{
                    transformOrigin: "312.808px 215.672px",
                }}
                id="prefix__eliykya1jboup"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M361.13 262.49c1.44-1.64 2-5.3 3.9-7.8s2.62-4.33 3.38-3.24c1 1.45-1.26 4.34-.76 4.63s2.38 4.1 2.57 6.22-5.42 7.44-5.42 7.44z"
                style={{
                    transformOrigin: "365.677px 260.434px",
                }}
                id="prefix__elzf7yull91mj"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M367.49 255.75s6.78-.58 7.77 0 .69 3.52 0 5.32-4.15 3-7.36 5.14c0-.32-.41-10.46-.41-10.46z"
                style={{
                    transformOrigin: "371.692px 260.851px",
                }}
                id="prefix__elmditmrijbqa"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M335.18 244.33c2.91 1 5.46 2.19 8.18 7.3 3.49 6.57 9.85 19.43 9.85 19.43l7.92-8.57s1.15-1.62 3.29 1.92 1.2 4.52 1.2 4.52-9.21 12.34-10.9 13.91-4.47.35-6.29-2.12-13.25-16.78-13.25-16.78-6.25-8.22 0-19.61z"
                style={{
                    transformOrigin: "349.114px 263.936px",
                }}
                id="prefix__el5mfw607ogme"
                className="prefix__animable"
                fill="#b16668"
              />
              <g id="prefix__elf93fslsr1o">
                  <path
                    d="M324.47 312.45l-.56-5.89a22.38 22.38 0 01-8.9-3.37s1.9 3 7.1 4.42l.54 7.5.32 12.3z"
                    style={{
                        transformOrigin: "319.74px 315.3px",
                    }}
                    className="prefix__animable"
                    id="prefix__elhz2x6io2aze"
                    opacity={0.2}
                  />
              </g>
              <path
                d="M303.7 242.77a10.27 10.27 0 0010.3-10.26v-15.59a7.84 7.84 0 00-10.26 7.46z"
                style={{
                    transformOrigin: "308.85px 229.654px",
                }}
                id="prefix__elfdo3y0tmde7"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M341.24 271.55s-5.69-7.34-7.51-10.29l7.71 16.28z"
                style={{
                    transformOrigin: "337.585px 269.4px",
                }}
                id="prefix__elagoz2z7ybis"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M391.13 211.27c-2.16 6.37-6.77 25.37-6.77 25.37s-8.79 11.69-11.21 13.92c-1.34 1.24-4.37 3.47-4.37 3.47l2.52 1.86s4.2-1.28 4.55 1a127.93 127.93 0 0012.4-11.4 8 8 0 002-3.66L394 225.7s0-13 2-14.7 1.21-5.55 1.21-5.55c-1.37.04-4.38.83-6.08 5.82z"
                style={{
                    transformOrigin: "383.072px 231.17px",
                }}
                id="prefix__elj49brue8jfl"
                className="prefix__animable"
                fill="#ffa8a7"
              />
              <path
                d="M397.28 204.81a36.14 36.14 0 002.22 5c.88 1.51-5.85 28.66-6.3 30.68s-13.5 13.79-13.5 13.79a9.8 9.8 0 01-5.22-5.24l9.42-12.26s2.93-12.86 4.47-18.76 3.18-12.57 8.91-13.21z"
                style={{
                    transformOrigin: "387.03px 229.545px",
                }}
                id="prefix__elvfcmcb8nati"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__elusfs4ykmp1">
                  <path
                    d="M397.28 204.81a36.14 36.14 0 002.22 5c.88 1.51-5.85 28.66-6.3 30.68s-13.5 13.79-13.5 13.79a9.8 9.8 0 01-5.22-5.24l9.42-12.26s2.93-12.86 4.47-18.76 3.18-12.57 8.91-13.21z"
                    style={{
                        transformOrigin: "387.03px 229.545px",
                    }}
                    className="prefix__animable"
                    id="prefix__el7kxir4i3xyy"
                    opacity={0.1}
                  />
              </g>
              <path
                style={{
                    transformOrigin: "421.59px 337.97px",
                }}
                id="prefix__elhnlnrqxhz16"
                className="prefix__animable"
                fill="#ffa8a7"
                d="M418.34 332.4h6.5v11.14h-6.5z"
              />
              <path
                style={{
                    transformOrigin: "394.83px 329.325px",
                }}
                id="prefix__el5yfzrpbwclw"
                className="prefix__animable"
                fill="#ffa8a7"
                d="M398.24 335.1l-6.5.23-.32-11.79 6.82-.22v11.78z"
              />
              <path
                d="M423.93 252.91c0 6.21.43 42.33.43 42.33.15 1.78 1.87 5 2 11.4.19 9.34-1.25 31.33-1.25 31.33a8.56 8.56 0 01-7.24.14s-5.11-31.1-6.27-40.35c-1-8.06-4.53-29.59-4.53-29.59l-5 27.26a37 37 0 01.81 10.34c-.31 4.27-4.27 25.68-4.27 25.68a8.88 8.88 0 01-7.51.58s-.39-33.61-.46-37.53c-.09-4.47 1.86-42.94 1.86-42.94z"
                style={{
                    transformOrigin: "408.507px 295.202px",
                }}
                id="prefix__elvs8sx04ukca"
                className="prefix__animable"
                fill="#37474f"
              />
              <path
                d="M418.34 340.33v-.93c-.35 0-.56.34-.7 1.17a16.88 16.88 0 01-.38 1.84 21.85 21.85 0 01-1.13 3.33c-.92 2.27-1.69 3.11-3.8 5.76a24.6 24.6 0 00-2 2.33c-.39.7-.53 2.64.14 3.09 2.45 1.64 6.18 1.68 8.82.91a5.34 5.34 0 003.83-4.3c.1-.6.06-1.22.13-1.82a8.68 8.68 0 011.63-3.78 11.66 11.66 0 001.25-2.06c.54-1.33.11-2.84-.24-4.17-.3-1.15-.63-2.41-1-2.3v.7a5.1 5.1 0 01-3.26 1.1c-.99.04-3.3-.15-3.29-.87z"
                style={{
                    transformOrigin: "418.194px 348.854px",
                }}
                id="prefix__elohs5elucnu"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M391.67 333.32c-.34 0-.61.49-1.36 1.3a14.37 14.37 0 01-3.82 2.75c-2.44 1.22-7.17 3.09-9.32 4.06-1.34.6-1.27 2.22.11 3.14s4.73 1.58 8.74.69c2.18-.49 5-2.51 6.83-2.4s5.17.08 6.5-.84.8-2.87.42-4.55c-.41-1.83-.92-4.7-1.53-4.57v.63c-.78 1.19-4.82 1.67-6.53.8z"
                style={{
                    transformOrigin: "388.203px 339.288px",
                }}
                id="prefix__elk6i3avqkczj"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M407.08 268.17A24.15 24.15 0 01398 263s1.75 3.28 7 6.32l-2.52 24.25z"
                style={{
                    transformOrigin: "402.54px 278.285px",
                }}
                id="prefix__el6y6w4i2xy2s"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M412.65 205.25c2.22.54 6.68 1.27 7.68 5.68 1.2 5.29 1.59 16.82 1.59 16.82l.41 25.66c-4.48 3.26-20.93 5-30.36-1.85 0 0 1.16-30.8 1.16-35.6s2.66-10.56 10-11z"
                style={{
                    transformOrigin: "407.15px 230.618px",
                }}
                id="prefix__elemc0bqz2mtq"
                className="prefix__animable"
                fill="#f5f5f5"
              />
              <path
                d="M403.25 204.48a13.1 13.1 0 00-4.2 6.5c-.9 3.88-1 47.21-1 47.21s-4.6-.85-6.75-2.54c0 0 .27-34.2.71-39.86.67-8.57.6-11 11.27-11.95z"
                style={{
                    transformOrigin: "397.29px 231.015px",
                }}
                id="prefix__elmcnhc86uf1c"
                className="prefix__animable"
                fill="#0b345a"
              />
              <path
                d="M414.59 203.84s-6.13 3.77-6.2 18.78c-.06 13-.49 35.57-.49 35.57s10.15 1.49 16.58-2.35c0 0 .77-31.46.64-36.33-.14-5.58-1.44-12.79-3.23-13.51a51.08 51.08 0 00-7.3-2.16z"
                style={{
                    transformOrigin: "416.517px 231.157px",
                }}
                id="prefix__elbqx5q8sccl"
                className="prefix__animable"
                fill="#0b345a"
              />
              <path
                d="M437.39 238.3c-6.1-24.94-10.61-33.26-18-33.16-2.17 2.58-1.57 10.4 1.85 15.14 0 0 7.63 16.08 8.84 21.8 1.07 5 2.28 11.35 2.21 15.67a3.15 3.15 0 01-.85 2.05c-1.39 1.51-1.4 2.73-2.3 4.4-.71 1.3-1.48 1.79-1.26 2.09a1.7 1.7 0 002.29.17 8.74 8.74 0 001.73-1.67 17.41 17.41 0 01-1.37 4.63c-1.57 3.53-1.19 5.33 3.58 4.07 3-.79 4.86-3.27 5.3-10.45a54.44 54.44 0 00.08-7.94c-.65-6.8-1.11-12.78-2.1-16.8z"
                style={{
                    transformOrigin: "428.858px 239.515px",
                }}
                id="prefix__ell0tq54krg2"
                className="prefix__animable"
                fill="#ffa8a7"
              />
              <path
                d="M418.1 204.73s4.91-.22 7.57 2.47 6.25 8.35 9.73 20.72 4.55 21.41 4.72 28.37c0 0-4.36 2-8.38-.28 0 0-1.78-10.77-3.36-16.5s-7.47-17.8-7.47-17.8-5.63-8.37-2.81-16.98z"
                style={{
                    transformOrigin: "428.715px 230.914px",
                }}
                id="prefix__el5ytllh68g5u"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__elujohpp292h">
                  <path
                    d="M418.1 204.73s4.91-.22 7.57 2.47 6.25 8.35 9.73 20.72 4.55 21.41 4.72 28.37c0 0-4.36 2-8.38-.28 0 0-1.78-10.77-3.36-16.5s-7.47-17.8-7.47-17.8-5.63-8.37-2.81-16.98z"
                    style={{
                        transformOrigin: "428.715px 230.914px",
                    }}
                    className="prefix__animable"
                    id="prefix__el2jzeiul0dzc"
                    opacity={0.1}
                  />
              </g>
              <g id="prefix__eldwas0k40ogk">
                  <path
                    style={{
                        transformOrigin: "412.735px 220.495px",
                    }}
                    className="prefix__animable"
                    id="prefix__elot3fkxeme5n"
                    opacity={0.1}
                    d="M415.28 212.05l-2.81 3.47 1.41 3.96-3.69 9.46 4.44-9.46-1.55-3.74 2.2-3.69z"
                  />
              </g>
              <g id="prefix__elb6mliu70cnc">
                  <path
                    style={{
                        transformOrigin: "395.35px 219.63px",
                    }}
                    className="prefix__animable"
                    id="prefix__eljkkoq8xtm6n"
                    opacity={0.1}
                    d="M395.48 210.93l.61 3.59-2.43 3.17 3.38 10.64-2.62-10.52 2.24-2.96-1.18-3.92z"
                  />
              </g>
              <g id="prefix__el40f7cfcptmo">
                  <circle
                    cx={402.13}
                    cy={183.87}
                    r={8.94}
                    style={{
                        transformOrigin: "402.13px 183.87px",
                    }}
                    className="prefix__animable"
                    id="prefix__ele345c7pwvl"
                    fill="#263238"
                    transform="rotate(-80.78)"
                  />
              </g>
              <path
                d="M417.58 190.23s-1.45 6.81-2 7.93a3.09 3.09 0 01-1.78 1.43l.1-4.79z"
                style={{
                    transformOrigin: "415.69px 194.91px",
                }}
                id="prefix__elyi1r2ftb24"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M415.76 180.48a3.35 3.35 0 012.78 1c1.19 1.22.53 5-1 8.77l-2.73.31z"
                style={{
                    transformOrigin: "416.981px 185.51px",
                }}
                id="prefix__elajgq01xyaxn"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M414 190.55c.55.32 1.33-.73 2-1.43a2.37 2.37 0 014 .64c1.12 2.36-1 5.48-2.7 6-3 .94-3.44-1-3.44-1l-.22 11.11c-2.07 2.65-6.71 5.77-9.21 5.32-2-.35-2.43-3.72-.52-5.93V202a18.61 18.61 0 01-4 .2c-2.2-.34-3.58-2.07-4.25-4.45-1.07-3.82-1.48-6.9-.57-14.42 1-8.24 10.58-8.32 15.75-5.07s3.16 12.29 3.16 12.29z"
                style={{
                    transformOrigin: "407.45px 193.748px",
                }}
                id="prefix__el19dl9tlyb3t"
                className="prefix__animable"
                fill="#ffa8a7"
              />
              <path
                d="M414 191.47c.28 0 1.33-1.73 2-2.35.94-.86-.28-8.64-.28-8.64a3.77 3.77 0 00-.65-4.2c-1.29-1.42-3.09-3.16-9-2.46-4.18.49-8.73 1.79-12.41 0a6.26 6.26 0 002.18 6.65 12.47 12.47 0 004.83 1.28 51.67 51.67 0 009.7-.18c1-.14 1.23.84 1.78 3.53.56 2.35.96 6.35 1.85 6.37z"
                style={{
                    transformOrigin: "404.889px 182.565px",
                }}
                id="prefix__elye7nh1553b"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M415.76 181.09l3.31-1.78a1.83 1.83 0 00-2.51-.83 2 2 0 00-.8 2.61z"
                style={{
                    transformOrigin: "417.314px 179.678px",
                }}
                id="prefix__ellgnfhfzqy5c"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M403.93 202a37.89 37.89 0 006.62-1.9 5.64 5.64 0 002.37-2.35 7.67 7.67 0 01-1.35 2.77c-1.25 1.6-7.64 2.78-7.64 2.78z"
                style={{
                    transformOrigin: "408.425px 200.525px",
                }}
                id="prefix__elcbelduq6jr"
                className="prefix__animable"
                fill="#f28f8f"
              />
              <path
                d="M405.11 189.32a1 1 0 102 0 1 1 0 00-1-1 1 1 0 00-1 1z"
                style={{
                    transformOrigin: "406.11px 189.32px",
                }}
                id="prefix__elg3kb42wjx6p"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M406.15 185.61l2.1 1.16a1.27 1.27 0 00-.49-1.68 1.17 1.17 0 00-1.61.52z"
                style={{
                    transformOrigin: "407.271px 185.86px",
                }}
                id="prefix__eljzmrfvqoljl"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M404.37 196.11l-2.24.84a1.17 1.17 0 001.52.75 1.26 1.26 0 00.72-1.59z"
                style={{
                    transformOrigin: "403.286px 196.941px",
                }}
                id="prefix__el4whi5csmk24"
                className="prefix__animable"
                fill="#f28f8f"
              />
              <path
                d="M396.34 186.43l1.92-1.48a1.17 1.17 0 00-1.67-.26 1.28 1.28 0 00-.25 1.74z"
                style={{
                    transformOrigin: "397.183px 185.44px",
                }}
                id="prefix__el0flr5a2z11g4"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M396.93 189a1 1 0 102 0 1 1 0 00-1-1 1 1 0 00-1 1z"
                style={{
                    transformOrigin: "397.93px 189px",
                }}
                id="prefix__elvt7hqibtu2f"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                style={{
                    transformOrigin: "400.235px 191.065px",
                }}
                id="prefix__elyt1qa743in"
                className="prefix__animable"
                fill="#f28f8f"
                d="M401.94 188.11l-.32 5.91-3.09-1.05 3.41-4.86z"
              />
              <path
                d="M400.87 210.55c.6 1.44 1.72 2 3.73 2.25a7.51 7.51 0 005.58-2l-2.5-2.49-3.19 2.39-.27-2.67z"
                style={{
                    transformOrigin: "405.525px 210.422px",
                }}
                id="prefix__elmgswjp7es8"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__eljpjjxrgfgo">
                  <path
                    d="M400.87 210.55c.6 1.44 1.72 2 3.73 2.25a7.51 7.51 0 005.58-2l-2.5-2.49-3.19 2.39-.27-2.67z"
                    style={{
                        transformOrigin: "405.525px 210.422px",
                    }}
                    className="prefix__animable"
                    id="prefix__elscdtcqtdyrk"
                    opacity={0.1}
                  />
              </g>
              <path
                d="M402.45 209.77a6.6 6.6 0 00-.33 2.69 4.57 4.57 0 00.9 2.23 2.44 2.44 0 002.16.24 5.94 5.94 0 002.07-4.49l-2.76.31z"
                style={{
                    transformOrigin: "404.673px 212.424px",
                }}
                id="prefix__elb2u42a3vwrf"
                className="prefix__animable"
                fill="#0b345a"
              />
              <path
                d="M403 214.69s-3.27 18-3.4 19.48 1.87 6.62 3.12 6.66 3.69-4.63 3.72-6-1.28-19.95-1.28-19.95z"
                style={{
                    transformOrigin: "403.017px 227.76px",
                }}
                id="prefix__el54943w7h2n9"
                className="prefix__animable"
                fill="#0b345a"
              />
              <g id="prefix__el3oh0bre5enw">
                  <path
                    d="M405.18 214.93a2.16 2.16 0 01-2.16-.24v.29a2.48 2.48 0 002.25.44z"
                    style={{
                        transformOrigin: "404.145px 215.106px",
                    }}
                    className="prefix__animable"
                    id="prefix__elurfyvhzt3ze"
                    opacity={0.1}
                  />
              </g>
              <path
                d="M404.49 210.75l9.2-7v-2.08s2.14.81 2.62 4.58a16.14 16.14 0 01-7.17 7.63l-1.93-3.44z"
                style={{
                    transformOrigin: "410.4px 207.775px",
                }}
                id="prefix__elpgpoalrnle"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M403.93 202.62a4.61 4.61 0 00-3 1.83c-.92 1.51-.71 7.32-.71 7.32l2.2-2 2 1c-.19-1.93-.57-5.45-.57-5.45z"
                style={{
                    transformOrigin: "402.31px 207.195px",
                }}
                id="prefix__elwgd2oqwowu"
                className="prefix__animable"
                fill="#e0e0e0"
              />
              <path
                d="M368 266.27a7.9 7.9 0 001.45-4.11c.26-1.89 5.44-3.92 5.61-2.51s.64 2.58-1 4.29-3.65 3.6-6.06 2.33z"
                style={{
                    transformOrigin: "371.627px 262.932px",
                }}
                id="prefix__el2twp0nrmp5f"
                className="prefix__animable"
                fill="#ffa8a7"
              />
              <path
                d="M368.27 254.06c-1.24 1.6-2 4.71-2.66 5.76s-1.44 2 0 2.15 3.53-2.61 4.31-4.31a4.6 4.6 0 011.34-1.72 3 3 0 01.75-.44c-.67-.23-.32-2.93-.79-3.3 0 0-2.44 1-2.95 1.86z"
                style={{
                    transformOrigin: "368.403px 257.088px",
                }}
                id="prefix__eldyzd4y3keqd"
                className="prefix__animable"
                fill="#ffa8a7"
              />
          </g>
      </g>
      <defs>
          <filter id="prefix__active" height="200%">
              <feMorphology
                in="SourceAlpha"
                result="DILATED"
                operator="dilate"
                radius={2}
              />
              <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
              <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
              <feMerge>
                  <feMergeNode in="OUTLINE" />
                  <feMergeNode in="SourceGraphic" />
              </feMerge>
          </filter>
          <filter id="prefix__hover" height="200%">
              <feMorphology
                in="SourceAlpha"
                result="DILATED"
                operator="dilate"
                radius={2}
              />
              <feFlood floodColor="red" floodOpacity={0.5} result="PINK" />
              <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
              <feMerge>
                  <feMergeNode in="OUTLINE" />
                  <feMergeNode in="SourceGraphic" />
              </feMerge>
              <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          </filter>
      </defs>
  </svg>
);

export default HeroImage;
